"use strict";

exports.__esModule = true;
exports.IndeterminateCheckbox = exports.DataTableTools = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _clsx = _interopRequireDefault(require("clsx"));

var _useDebounce = _interopRequireDefault(require("../../hooks/useDebounce"));

var _Input = _interopRequireDefault(require("../Input/Input"));

var _Select = _interopRequireDefault(require("../Select/Select"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Switch = _interopRequireDefault(require("../Switch/Switch"));

var _Dropdown = _interopRequireDefault(require("../Dropdown/Dropdown"));

var _Checkbox = _interopRequireDefault(require("../Checkbox/Checkbox"));

var _excluded = ["indeterminate"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IndeterminateCheckbox = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var indeterminate = _ref.indeterminate,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var defaultRef = _react.default.useRef();

  var resolvedRef = ref || defaultRef;

  _react.default.useEffect(function () {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-checkbox small primary outline"
  }, /*#__PURE__*/_react.default.createElement("label", null, /*#__PURE__*/_react.default.createElement("input", _extends({
    type: "checkbox",
    ref: resolvedRef,
    className: "checkbox-input"
  }, rest)), indeterminate ? /*#__PURE__*/_react.default.createElement("span", {
    className: "checkbox--fake"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "indeterminate"
  })) : /*#__PURE__*/_react.default.createElement("span", {
    className: "checkbox--fake"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "checkmark"
  }))));
});

exports.IndeterminateCheckbox = IndeterminateCheckbox;

var ColumnsToggle = function ColumnsToggle(_ref2) {
  var allColumns = _ref2.allColumns,
      flatColumns = _ref2.flatColumns,
      setColumnOrder = _ref2.setColumnOrder,
      _ref2$tools = _ref2.tools,
      selectable = _ref2$tools.selectable,
      columnsToggle = _ref2$tools.columnsToggle;

  var currentColOrder = _react.default.useRef();

  var getItemStyle = function getItemStyle(_ref3, draggableStyle) {
    var isDragging = _ref3.isDragging,
        isDropAnimating = _ref3.isDropAnimating;
    return _extends({}, draggableStyle, {
      userSelect: 'none',
      background: isDragging ? 'lightgreen' : false
    });
  };

  if (selectable) allColumns.shift();
  return /*#__PURE__*/_react.default.createElement(_Dropdown.default, {
    className: "uk-data-table__columns-toggle",
    align: "right",
    trigger: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("i", {
      className: "fa fa-columns"
    }))
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__columns-toggle-title"
  }, columnsToggle.label), /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragStart: function onDragStart() {
      currentColOrder.current = allColumns.map(function (o) {
        return o.id;
      });
    },
    onDragUpdate: function onDragUpdate(dragUpdateObj, b) {
      var colOrder = [].concat(currentColOrder.current);
      var sIndex = dragUpdateObj.source.index;
      var dIndex = dragUpdateObj.destination && dragUpdateObj.destination.index;

      if (typeof sIndex === 'number' && typeof dIndex === 'number') {
        colOrder.splice(sIndex, 1);
        colOrder.splice(dIndex, 0, dragUpdateObj.draggableId);
        setColumnOrder(colOrder);
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "droppable",
    direction: "vertical"
  }, function (droppableProvided, snapshot) {
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: droppableProvided.innerRef
    }, allColumns.map(function (column, index) {
      return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
        key: column.id,
        draggableId: column.id,
        index: index,
        isDragDisabled: !column.accessor
      }, function (provided, snapshot) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "draggable-anchor",
          ref: provided.innerRef,
          style: _extends({}, getItemStyle(snapshot, provided.draggableProps.style))
        }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, _extends({
          size: "tiny",
          id: column.id,
          label: column.Header
        }, column.getToggleHiddenProps(), {
          onChange: function onChange(checked, name, event) {
            return column.getToggleHiddenProps().onChange(event);
          }
        })), /*#__PURE__*/_react.default.createElement("div", _extends({}, provided.draggableProps, provided.dragHandleProps), /*#__PURE__*/_react.default.createElement("i", {
          className: "fa fa-grip-lines"
        })));
      });
    }), droppableProvided.placeholder);
  }))));
};

var Toggle = function Toggle(_ref4) {
  var allColumns = _ref4.allColumns,
      filterToggle = _ref4.tools.filterToggle,
      filters = _ref4.initialState.filters;

  if (filters) {
    var t = filters.filter(function (f) {
      return f.id === filterToggle.key;
    });
    return allColumns.filter(function (f) {
      return f.id === filterToggle.key;
    }).map(function (column) {
      return /*#__PURE__*/_react.default.createElement(_Switch.default, {
        key: column.id,
        onChange: function onChange(e) {
          return column.setFilter(e ? undefined : t[0].value);
        },
        checked: column.filterValue !== t[0].value,
        id: "uk-data-table__toggle-" + column.id,
        size: "small",
        color: "primary",
        label: filterToggle.label
      });
    });
  }

  return null;
};

var BackendToggle = function BackendToggle(_ref5) {
  var allColumns = _ref5.allColumns,
      filterToggle = _ref5.tools.filterToggle,
      filters = _ref5.initialState.filters,
      setBackEndFilter = _ref5.setBackEndFilter;

  if (filters) {
    return allColumns.filter(function (f) {
      return f.id === filterToggle.key;
    }).map(function (column) {
      return /*#__PURE__*/_react.default.createElement(_Switch.default, {
        key: column.id,
        onChange: setBackEndFilter,
        id: "uk-data-table__toggle-" + column.id,
        size: "small",
        color: "primary",
        label: filterToggle.label
      });
    });
  }

  return null;
};

var Filter = function Filter(_ref6) {
  var globalFilter = _ref6.state.globalFilter,
      setGlobalFilter = _ref6.setGlobalFilter,
      rows = _ref6.rows,
      _ref6$context = _ref6.context,
      state = _ref6$context.state,
      dispatch = _ref6$context.dispatch,
      filterInput = _ref6.tools.filterInput;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)('uk-data-table__search', globalFilter && 'uk-data-table__search--filled')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__entries-filter"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    placeholder: filterInput.placeholder,
    value: globalFilter,
    onChange: setGlobalFilter,
    clearable: true
  }), !globalFilter && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "search"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "uk-data-table__entries-count"
  }, rows.length > 0 ? rows.length + " " + (rows.length === 1 ? filterInput.entry : filterInput.entries) : "0 " + filterInput.entry));
};

var BackendFilter = function BackendFilter(_ref7) {
  var rows = _ref7.rows,
      filterInput = _ref7.tools.filterInput,
      entriesCount = _ref7.entriesCount,
      loading = _ref7.loading,
      searchTerm = _ref7.searchTerm,
      setSearchTerm = _ref7.setSearchTerm;

  var _React$useState = _react.default.useState(searchTerm),
      search = _React$useState[0],
      setSearch = _React$useState[1];

  var debouncedSearch = (0, _useDebounce.default)(search, 500);

  _react.default.useEffect(function () {
    return setSearchTerm(debouncedSearch || '');
  }, [debouncedSearch, setSearchTerm]);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__search"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__entries-filter"
  }, /*#__PURE__*/_react.default.createElement(_Input.default, {
    placeholder: filterInput.placeholder,
    value: searchTerm,
    onChange: setSearch,
    clearable: true
  }), !searchTerm && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "search"
  })), !loading && /*#__PURE__*/_react.default.createElement("span", {
    className: "uk-data-table__entries-count"
  }, rows.length > 0 ? entriesCount + " " + (entriesCount === 1 ? filterInput.entry : filterInput.entries) : "0 " + filterInput.entry));
};

var Pages = function Pages(_ref8) {
  var pageSize = _ref8.state.pageSize,
      setPageSize = _ref8.setPageSize;
  return /*#__PURE__*/_react.default.createElement(_Select.default, {
    className: "uk-data-table__pages",
    onChange: function onChange(ps) {
      return setPageSize(Number(ps));
    },
    value: pageSize,
    options: [5, 10, 20, 50, 100].map(function (pSize) {
      return {
        label: pSize,
        value: pSize
      };
    }),
    defaultValue: "10"
  });
};

var BackendPages = function BackendPages(_ref9) {
  var pageSize = _ref9.state.pageSize,
      setPageSize = _ref9.setPageSize,
      setPIndex = _ref9.setPIndex;
  return /*#__PURE__*/_react.default.createElement(_Select.default, {
    className: "uk-data-table__pages",
    onChange: function onChange(ps) {
      setPageSize(Number(ps));
      setPIndex(0);
    },
    value: pageSize,
    options: [5, 10, 20, 50, 100].map(function (pSize) {
      return {
        label: pSize,
        value: pSize
      };
    }),
    defaultValue: "10"
  });
};

var Pagination = function Pagination(_ref10) {
  var pageIndex = _ref10.state.pageIndex,
      canPreviousPage = _ref10.canPreviousPage,
      canNextPage = _ref10.canNextPage,
      gotoPage = _ref10.gotoPage,
      nextPage = _ref10.nextPage,
      previousPage = _ref10.previousPage,
      pageOptions = _ref10.pageOptions,
      pageCount = _ref10.pageCount;

  if (pageCount <= 1) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-label": "Table navigation",
    className: "uk-data-table__pagination"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "uk-pagination"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return gotoPage(0);
    },
    disabled: !canPreviousPage,
    className: "uk-pagination__link uk-pagination--first-page",
    color: "secondary",
    outline: true,
    icon: "angle-double-left"
  })), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return previousPage();
    },
    disabled: !canPreviousPage,
    className: "uk-pagination__link uk-pagination--previous-page",
    color: "secondary",
    outline: true,
    icon: "angle-left"
  })), // eslint-disable-next-line no-shadow
  Array.from(Array(pageOptions.length).keys()).map(function (page, p) {
    if (p < pageIndex + 3 && p > pageIndex - 3) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "uk-pagination__item uk-pagination__item--page " + (pageIndex === p ? ' active' : ''),
        key: p
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        className: "uk-pagination__link",
        color: "secondary",
        outline: pageIndex !== p,
        label: String(p + 1),
        onClick: function onClick() {
          return gotoPage(p);
        }
      }));
    }

    return undefined;
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return nextPage();
    },
    disabled: !canNextPage,
    className: "uk-pagination__link uk-pagination--next-page",
    color: "secondary",
    outline: true,
    icon: "angle-right"
  })), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return gotoPage(pageCount - 1);
    },
    disabled: !canNextPage,
    className: "uk-pagination__link uk-pagination--last-page",
    color: "secondary",
    outline: true,
    icon: "angle-double-right"
  }))));
};

var BackendPagination = function BackendPagination(_ref11) {
  var pageCount = _ref11.pageCount,
      pIndex = _ref11.pIndex,
      setPIndex = _ref11.setPIndex;
  if (isNaN(pageCount) || pageCount <= 1) return null;
  var uiProps = {
    className: 'uk-pagination__link',
    color: 'secondary',
    outline: true
  };
  return /*#__PURE__*/_react.default.createElement("nav", {
    "aria-label": "Table navigation",
    className: "uk-data-table__pagination"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: "uk-pagination"
  }, /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    onClick: function onClick() {
      return setPIndex(0);
    },
    disabled: pIndex - 1 < 0,
    icon: "angle-double-left"
  }, uiProps))), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    onClick: function onClick() {
      return setPIndex(pIndex - 1);
    },
    disabled: pIndex - 1 < 0,
    icon: "angle-left"
  }, uiProps))), pageCount && Array.from(Array(pageCount)).map(function (page, p) {
    if (p < pIndex + 3 && p > pIndex - 3) {
      return /*#__PURE__*/_react.default.createElement("li", {
        className: "uk-pagination__item uk-pagination__item--page " + (pIndex === p ? ' active' : ''),
        key: p
      }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
        onClick: function onClick() {
          return setPIndex(p);
        },
        label: String(p + 1)
      }, uiProps, {
        outline: pIndex !== p
      })));
    }

    return undefined;
  }), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    onClick: function onClick() {
      return setPIndex(pIndex + 1);
    },
    disabled: pIndex >= pageCount - 1,
    icon: "angle-right"
  }, uiProps))), /*#__PURE__*/_react.default.createElement("li", {
    className: "uk-pagination__item"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
    onClick: function onClick() {
      return setPIndex(pageCount - 1);
    },
    disabled: pIndex >= pageCount - 1,
    icon: "angle-double-right"
  }, uiProps)))));
};

var Pager = function Pager(_ref12) {
  var pageIndex = _ref12.state.pageIndex,
      pageCount = _ref12.pageCount,
      pageOptions = _ref12.pageOptions,
      gotoPage = _ref12.gotoPage;

  if (pageCount <= 1) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__pager"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-margin"
  }, "Page"), /*#__PURE__*/_react.default.createElement(_Input.default, {
    min: 1,
    max: pageOptions.length,
    type: "number",
    value: pageIndex + 1,
    onChange: function onChange(e) {
      var clampedStep = Math.min(Math.max(Number(e) - 1, 0), pageOptions.length - 1);
      gotoPage(clampedStep);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "text-margin"
  }, "/"), /*#__PURE__*/_react.default.createElement("span", null, pageOptions.length));
};

var BackendPager = function BackendPager(_ref13) {
  var pageCount = _ref13.pageCount,
      pIndex = _ref13.pIndex,
      setPIndex = _ref13.setPIndex;
  if (isNaN(pageCount) || pageCount <= 1) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "uk-data-table__pager"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-margin"
  }, "Page"), /*#__PURE__*/_react.default.createElement(_Input.default, {
    min: 1,
    max: pageCount,
    type: "number",
    value: pIndex + 1,
    onChange: function onChange(e) {
      var clampedStep = Math.min(Math.max(Number(e) - 1, 0), pageCount);
      setPIndex(clampedStep);
    }
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "text-margin"
  }, "/"), /*#__PURE__*/_react.default.createElement("span", null, pageCount));
};

var DataTableTools = function DataTableTools(_ref14) {
  var position = _ref14.position,
      instance = _ref14.instance,
      children = _ref14.children;
  var hasBackEndManagment = instance.hasBackEndManagment,
      tools = instance.tools;
  var elements = Object.keys(tools).filter(function (key) {
    return tools[key].position === position;
  });

  if (elements.length) {
    var output = elements.map(function (element, i) {
      switch (element) {
        case 'filterInput':
          return hasBackEndManagment ? /*#__PURE__*/_react.default.createElement(BackendFilter, _extends({
            key: i
          }, instance)) : /*#__PURE__*/_react.default.createElement(Filter, _extends({
            key: i
          }, instance));

        case 'filterToggle':
          return hasBackEndManagment ? /*#__PURE__*/_react.default.createElement(BackendToggle, _extends({
            key: i
          }, instance)) : /*#__PURE__*/_react.default.createElement(Toggle, _extends({
            key: i
          }, instance));

        case 'pages':
          return hasBackEndManagment ? /*#__PURE__*/_react.default.createElement(BackendPages, _extends({
            key: i
          }, instance)) : /*#__PURE__*/_react.default.createElement(Pages, _extends({
            key: i
          }, instance));

        case 'pagination':
          return hasBackEndManagment ? /*#__PURE__*/_react.default.createElement(BackendPagination, _extends({
            key: i
          }, instance)) : /*#__PURE__*/_react.default.createElement(Pagination, _extends({
            key: i
          }, instance));

        case 'columnsToggle':
          return /*#__PURE__*/_react.default.createElement(ColumnsToggle, _extends({
            key: i
          }, instance));

        case 'pager':
          return hasBackEndManagment ? /*#__PURE__*/_react.default.createElement(BackendPager, _extends({
            key: i
          }, instance)) : /*#__PURE__*/_react.default.createElement(Pager, _extends({
            key: i
          }, instance));

        default:
          return /*#__PURE__*/_react.default.createElement("div", null);
      }
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "uk-data-table__tool"
    }, children, output);
  }

  return null;
};

exports.DataTableTools = DataTableTools;